// Flow element inside the host's controls overlay (the host positions the
// container over the map). Relative so the results dropdown anchors to it.
.root {
  position: relative;
  width: 100%;
}

// Legacy parity: the clear affordance is a plain × glyph (no box, border or
// background), sitting in the Input's trailing slot. Inherits the muted icon
// colour from the slot; darkens on hover.
.clear {
  align-items: center;
  background: none;
  border: 0;
  color: inherit;
  cursor: pointer;
  display: flex;
  padding: 0;

  &:hover {
    color: var(--color-foreground);
  }
}

// Absolutely positioned so it floats over sibling controls (e.g. a region
// picker rendered below) instead of pushing them down. High z-index keeps
// the geocode suggestions above those siblings.
.results {
  background: var(--color-background);
  border: 1px solid var(--color-border);
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  left: 0;
  margin-top: 4px;
  max-height: 240px;
  overflow-y: auto;
  position: absolute;
  right: 0;
  top: 100%;
  z-index: 30;
}

.result {
  background: transparent;
  border: 0;
  border-bottom: 1px solid var(--color-border);
  color: var(--color-foreground);
  cursor: pointer;
  font: inherit;
  padding: 8px 10px;
  text-align: left;

  &:last-child {
    border-bottom: 0;
  }

  &:hover {
    background: var(--color-secondary);
  }
}
